import { render } from "./AdminSetLavelUser.vue?vue&type=template&id=56facae4"
import script from "./AdminSetLavelUser.vue?vue&type=script&lang=js"
export * from "./AdminSetLavelUser.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__